export { Caption2 } from './Caption2';
export { caption2ClassNames } from './useCaption2Styles.styles';
